<template>
    <form-main @back="makeSureBack">
        <template slot="nav">
            <div class="vita-form-basic-nav">
                <p>基本信息
<!--                    <span style="font-size: 16px;color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(您填写的内容将后续用于颁发教练员证书和执照等，同时进入中国足协信息数据库，简历信息填写不完整将会影响更高一级教练员培训的录取)</span>-->
                </p>
                <p @click="jumpResume" class="myResume" v-if="showMyResume">简历内容</p>
                <p class=" not_allow" v-else>简历内容</p>
            </div>
        </template>
        <template slot="main">
            <div class="vita-form-main-basic">
                <div class="content">
                    <template v-if="!isLoading">
                        <vue-scroll :ops="ops">
                            <div class="form-wrap">
                                <el-form :model="vitaForm"
                                         :rules="rules"
                                         ref="vitaForm"
                                         label-width="100px"
                                         size="medium">
                                    <fieldset class="vita-form-fieldset" v-if="auditData.length>0 && !isFive">
                                        <legend>信息审核流程</legend>
                                        <div class="timeline">
                                            <div
                                                    class="timeline-item"
                                                    v-for="(audit, i) in auditData"
                                                    :key="audit.audit_id"
                                            >
                                                <div
                                                        class="item_tail"
                                                        v-show="i !== auditData.length - 1"
                                                ></div>
                                                <div class="item_node" v-if="audit.audit_type === 'audit_info'">
                                                    {{ audit.status |auditStatus }}
                                                </div>
                                              <div class="item_node" v-else-if="audit.audit_type === 'revocation_info'">
                                                撤销
                                              </div>
                                                <div class="item_node" v-else>
                                                    提交
                                                </div>
                                                <div class="item_wrap">
                                                    <div class="timestamp">
                                                        <span >{{ audit.create_time | time }}</span>
<!--                                                        <span class="audit_people" v-if="audit.audit_type==='submit_qua'">提交人：{{ audit.user_name }}</span>-->
<!--                                                        <span class="audit_people" v-else>审核人：{{ audit.user_name }}</span>-->
                                                    </div>
                                                    <div class="item_cont">
                                                        <p>
                                                            <span v-if="audit.audit_type==='submit_info'">证照信息审核提交成功，每年6月和12月为集中审核窗口期，请您耐心等待。</span>
                                                          <span v-else-if="audit.audit_type==='revocation_info'">撤回提交信息审核</span>
                                                            <span v-else>审核</span>
                                                            <span v-if="audit.audit_type !== 'submit_info' && audit.msg_info">：{{ audit.msg_info }}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <!-- 个人信息 -->
                                    <fieldset class="vita-form-fieldset">
                                        <legend>个人信息</legend>
                                        <el-form-item label-width="100px">
                                            <el-row>
                                                <el-col :span="9">
                                                    <!--<vita-card :imgUrl.sync="cardFront"
                                                               tips="身份证正面"
                                                               @imgChange="cardFrontImgChange"></vita-card>-->
                                                    <div class="idcard-front-end" :class="{basic_information_forbidden_click:not_allow_change }">
                                                        <!--<vita-photo :w="260" :dw="'600px'" :h="160"-->
                                                                    <!--:imgUrl.sync="cardFront" :disabled="not_allow_change "></vita-photo>-->
                                                        <vita-img ref="vitaImgInfoFront" :imgUrl.sync="cardFront" :w="260" :h="160"  :dw="'600px'" :disabled="not_allow_change " :photoType="'Card'" :cardType="'identify_edit1'"></vita-img>
                                                        <div v-show="showTipsFront"
                                                             class="front-end-tips front-tips">
                                                            <img :src="tipsFront" alt="">
                                                        </div>
                                                    </div>
                                                </el-col>
                                                <el-col :span="9">
                                                    <!--<vita-card :imgUrl.sync="cardBack"
                                                               tips="身份证反面"
                                                               @imgChange="cardBackImgChange"></vita-card>-->
                                                    <div class="idcard-front-end" :class="{basic_information_forbidden_click:not_allow_change}">
                                                        <!--<vita-photo  :w="260" :dw="'600px'" :h="160"-->
                                                                    <!--:imgUrl.sync="cardBack" :disabled="not_allow_change  "></vita-photo >-->
                                                        <vita-img ref="vitaImgInfoFront" :imgUrl.sync="cardBack" :w="260" :h="160"  :dw="'600px'" :disabled="not_allow_change " :photoType="'Card'" :cardType="'identify_edit2'"></vita-img>
                                                        <div v-show="showTipsEnd"
                                                             class="front-end-tips end-tips">
                                                            <img :src="tipsEnd" alt="">
                                                        </div>
                                                    </div>
                                                </el-col>
                                                <el-col :span="5" :offset="1">
                                                    <div class="photo" :class="{basic_information_forbidden_click:not_allow_change }">
                                                        <vita-img ref="vitaImgInfo" :imgUrl.sync="photo" :disabled="not_allow_change " :photoType="'photo'"></vita-img>
                                                        <div v-show="showTipsPhoto"
                                                             class="tips-photo">
                                                            <img :src="tipsPhoto" alt="">
                                                        </div>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
<!--                                        性别和拼音出现形式判断-->
<!--                                        1 被拒绝-->
                                        <template v-if="!not_allow_change">
                                            <el-row>
                                                <el-col :span="7">
                                                    <el-form-item label="姓名" prop="name">
                                                        <el-input v-model.trim="vitaForm.name"
                                                                  :disabled="true"
                                                                  placeholder="请输入姓名"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="7">
                                                    <el-form-item label="性别"
                                                                  prop="gender"
                                                                  class="gender">
                                                        <el-select v-model="noEdit.gender"
                                                                   :disabled="true"
                                                                   style="width: 137px"
                                                                   placeholder="请选择性别">
                                                            <el-option
                                                                    v-for="item in gender"
                                                                    :key="item.val"
                                                                    :label="item.key"
                                                                    :value="item.val">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="10" style="display: flex;align-items: center;height: 37px;padding-left: 35px">
                                                    <el-switch
                                                            v-model="switch_pinyin"
                                                            @change="changePinyin"
                                                    >
                                                    </el-switch>
                                                    <span  style="margin-left: 5px">姓名不区分姓氏和名的少数民族学员</span>
                                                </el-col>
                                            </el-row>
                                            <el-row v-if="switch_pinyin">
                                                <el-col :span="24">
                                                    <el-form-item label="姓名(拼音)" prop="family_name_spell">
                                                        <el-autocomplete
                                                                v-if="id_type==='id_number'"
                                                                style="width: 100%"
                                                                v-model="vitaForm.family_name_spell"
                                                                :disabled="not_allow_change"
                                                                :fetch-suggestions="name_spell_search"
                                                                placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"
                                                        ></el-autocomplete>
                                                        <el-input v-else v-model.trim="vitaForm.family_name_spell"
                                                                  placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row v-else>
                                                <el-col :span="12">
                                                    <el-form-item label="姓氏(拼音)" prop="family_name_spell">
                                                        <el-autocomplete
                                                                v-if="id_type==='id_number'"
                                                                style="width: 100%"
                                                                v-model="vitaForm.family_name_spell"
                                                                :fetch-suggestions="familyNameSearch"
                                                                placeholder="请输入拼音大写,例如张三,输入:ZHANG"
                                                        ></el-autocomplete>
                                                        <el-input v-else v-model.trim="vitaForm.family_name_spell"

                                                                  placeholder="请输入拼音大写,例如张三,输入:ZHANG"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="名(拼音)" prop="given_name_spell">
                                                        <el-autocomplete
                                                                v-if="id_type==='id_number'"
                                                                style="width: 100%"
                                                                v-model="vitaForm.given_name_spell"
                                                                :fetch-suggestions="givenNameSearch"
                                                                placeholder="请输入拼音大写,例如张三,输入:SAN"
                                                        ></el-autocomplete>
                                                        <el-input  v-else v-model.trim="vitaForm.given_name_spell"
                                                                  placeholder="请输入拼音大写,例如张三,输入:SAN"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </template>
                                        <template v-else>
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item label="姓名" prop="name">
                                                        <el-input v-model.trim="vitaForm.name"
                                                                  :disabled="true"
                                                                  placeholder="请输入姓名"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="性别"
                                                                  prop="gender"
                                                                  class="gender">
                                                        <el-select v-model="noEdit.gender"
                                                                   :disabled="true"
                                                                   style="width:100%"
                                                                   placeholder="请选择性别">
                                                            <el-option
                                                                    v-for="item in gender"
                                                                    :key="item.val"
                                                                    :label="item.key"
                                                                    :value="item.val">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row v-if="switch_pinyin">
                                                <el-col :span="24">
                                                    <el-form-item label="姓名(拼音)" prop="family_name_spell">
                                                        <el-autocomplete
                                                                v-if="id_type==='id_number'"
                                                                style="width: 100%"
                                                                v-model="vitaForm.family_name_spell"
                                                                :disabled="true"
                                                                :fetch-suggestions="name_spell_search"
                                                                placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"
                                                        ></el-autocomplete>
                                                        <el-input v-else v-model.trim="vitaForm.family_name_spell"
                                                                  placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row v-else>
                                                <el-col :span="12">
                                                    <el-form-item label="姓氏(拼音)" prop="family_name_spell">
                                                        <el-autocomplete
                                                                v-if="id_type==='id_number'"
                                                                style="width: 100%"
                                                                :disabled="true"
                                                                v-model="vitaForm.family_name_spell"
                                                                :fetch-suggestions="familyNameSearch"
                                                                placeholder="请输入拼音大写,例如张三,输入:ZHANG"
                                                        ></el-autocomplete>
                                                        <el-input v-else v-model.trim="vitaForm.family_name_spell"
                                                                  :disabled="true"
                                                                  placeholder="请输入拼音大写,例如张三,输入:ZHANG"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="名(拼音)" prop="given_name_spell">
                                                        <el-autocomplete
                                                                v-if="id_type==='id_number'"
                                                                style="width: 100%"
                                                                v-model="vitaForm.given_name_spell"
                                                                :disabled="true"
                                                                :fetch-suggestions="givenNameSearch"
                                                                placeholder="请输入拼音大写,例如张三,输入:SAN"
                                                        ></el-autocomplete>
                                                        <el-input v-else  :disabled="true" v-model.trim="vitaForm.given_name_spell"
                                                                  placeholder="请输入拼音大写,例如张三,输入:SAN"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="国籍" prop="nationality" class="national">
                                                    <el-select v-model="vitaForm.nationality"
                                                      filterable
                                                      :disabled="not_allow_change"
                                                      placeholder="请选择国籍">
                                                        <el-option
                                                          v-for="item in countryArr"
                                                          :key="item.country_code"
                                                          :label="item.country_zh"
                                                          :value="item.country_code">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="民族" prop="nation" class="national"
                                                  :rules="{required: vitaForm.nationality ==='CN', message: `请选择民族`, trigger: `change`}">
                                                    <el-select v-model="vitaForm.nation"
                                                      filterable
                                                      :disabled="not_allow_change"
                                                      placeholder="请选择民族">
                                                        <el-option
                                                          v-for="item in nationArr"
                                                          :key="item.nation_zh"
                                                          :label="item.nation_zh"
                                                          :value="item.nation_zh">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="手机">
                                                    <el-input v-model="noEdit.phone"
                                                              :disabled="true"
                                                              placeholder="请输入手机号"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="出生日期"
                                                              prop="birthday">
                                                    <!--<el-form-item label="出生日期"
                                                                  prop="date_of_birth"
                                                                  class="birthday">
                                                      <el-date-picker
                                                          v-model="vitaForm.date_of_birth"
                                                          type="date"
                                                          :disabled="true"
                                                          placeholder="请选择日期">
                                                      </el-date-picker>-->
                                                      <el-date-picker
                                                            style="width:100%"
                                                            v-model="vitaForm.birthday"
                                                            type="date"
                                                            :picker-options="option"
                                                            value-format="yyyy-MM-dd"
                                                            :disabled="!canChangeBirthday "
                                                            placeholder="请选择出生日期">
                                                        </el-date-picker>
                                                    <!-- <el-input v-model="noEdit.birthDay"
                                                              :disabled="true"></el-input> -->
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="证件号">
                                                    <el-input v-model.trim="noEdit.idNum"
                                                              :disabled="true"

                                                              placeholder="请输入证件号"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="电子邮箱" prop="email_address">
                                                    <el-autocomplete
                                                            class="inline-input"
                                                            style="width: 100%"
                                                            v-model.trim="vitaForm.email_address"
                                                            :fetch-suggestions="querySearch"
                                                            :disabled="not_allow_change "
                                                            placeholder="请输入电子邮箱"
                                                            :trigger-on-focus="false"
                                                    ></el-autocomplete>
<!--                                                    <el-input v-model.trim="vitaForm.email_address"-->
<!--                                                              :disabled="not_allow_change "-->
<!--                                                              placeholder="电子邮箱信息可用来找回帐号密码"></el-input>-->
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="注册足协">
                                                    <el-input v-model.trim="noEdit.org_abbreviation"
                                                      :disabled="true"
                                                      ></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </fieldset>

                                </el-form>
                            </div>
                        </vue-scroll>
                    </template>
                    <template v-else>
                        <yioks-loading></yioks-loading>
                    </template>
                </div>
              <div class="btns" v-show="memberType==='expireStudent' && (info_status === 'audit' || info_status === 'edit' )">
                <el-button type="danger" @click="revocation">撤销提交</el-button>
              </div>
                <div class="btns" v-show="!not_allow_change">
                    <el-button type="primary"
                               v-if="memberType==='expireStudent'"
                               @click="checkForm('commit')">提交
                    </el-button>
                    <el-button type="primary"
                               v-else
                               @click="checkForm('save')">保存
                    </el-button>
                    <el-button type="danger"
                               @click="makeSureBack">取消</el-button>
                </div>
                <yioks-tips :showTips="submitTips"
                            :tips="tips"
                            @hideTips="hideSubmitTips"></yioks-tips>
                <yioks-tips :showTips="backTips"
                            tips="确认是否放弃提交?"
                            @hideTips="hideBackTips"></yioks-tips>
                <yioks-tips :showTips="dataSettingTips"
                            tips="确认是否放弃提交?"
                            @hideTips="hideSettingTips"></yioks-tips>
              <yioks-tips :showTips="revocationBackTips"
                          tips="确认撤销信息提交?"
                          @hideTips="hideBackTipsRevocation"></yioks-tips>
                <yioks-iKnow :showTips="iKnowTips" tips="电子相片要求为照相馆拍摄的本人清晰2寸白底证件照，将会用于教练员执照生成和人脸识别（翻拍或扫描相片、翻牌或扫描身份证照片、自拍照、非白底照、生活照、相片头顶无留白或不显示肩膀均为不合格）" @hideTips="iKnowHideTips"></yioks-iKnow>
            </div>
        </template>
    </form-main>
</template>

<script>
    import ops from "@/assets/js/vuescrollOption";
    import fieldMixin from "@/views/training_student/vita/mixin/data-field";
    import uploadMixin from "@/views/training_student/vita/mixin/upload-imgs";
    import optMixin from "@/views/training_student/vita/mixin/exp-options";
    import echoMixin from "@/views/training_student/vita/mixin/data-rules";
    import rulesMixin from "@/views/training_student/vita/mixin/form-rules";
    import {info_revocation, student_sign_info_one} from "@/api/training_student/vita";
    import { mapMutations } from "vuex";
    import {qualificationList , teamList } from "@/assets/js/select";
    import fiveMixins from "@/minix/fiveMixins";
    import pinyin from '@/minix/pinyin';
    import { checkPicture } from '@/api/common/api';
    export default {
        mixins: [fieldMixin, uploadMixin, optMixin, echoMixin, rulesMixin,pinyin,fiveMixins],
        name: "basicSetting",
        data() {
            const shoesNum = [];
            for (let i = 0; ; i++) {
                const num = 35+0.5*i;
                if(num > 50) break;
                shoesNum.push(num);
            }
            const wearNum = ['S','M','L','XL','XXL','XXXL'];
            return {
                shoesNum,
                wearNum,
                dataSettingTips:false,
              revocationBackTips:false,
                picture_not_allow:true,
                tips:'',
                verso_not_allow:true,
                front_not_allow:true,
               name_family_not_allow:true,
                name_given_not_allow:true,
                email_address_not_allow:true,
                showMyResume:false,
                ops: ops(),
                backTips: false,
                submitTips: false,
                iKnowTips: false,
                tmpLanguageRow: [],
                tmpEduExp: [],
                tmpTrainExp: [],
                auditData: [],
                tmpTeaExp: [],
                tmpSportsExp: [],
                userInfo: this.$store.state.userInfo,
                qualificationList,
                teamList
            };
        },
        components: {
            "form-main": () => import("@/components/LayOut/Common/up-down"),
            "yioks-loading": () => import("@/components/Loading/Loading"),
            "vita-photo": () => import("@/components/UpImage/vita-upload"),
            "vita-img": () => import("@/components/UpImage/up-img"),
            "yioks-tips": () => import('@/components/Tips/Dialog'),
            "yioks-iKnow": () => import('@/components/Tips/iKnow'),
        },
        methods: {
            ...mapMutations(["updateUserInfo", "updateUserImg"]),
            goBack() {
                if (this.memberType==='expireStudent'){
                    this.$router.push('expire_index')
                } else{
                    this.$router.go(-1)
                }

            },
            changePinyin(){
                this.vitaForm. given_name_spell='';
                this.$refs["vitaForm"].validateField("family_name_spell");
            },
            makeSureBack() {
                if (this.not_allow_change ){
                    this.$router.go(-1)
                } else{
                    this.backTips = true;
                }

            },
            jumpResume(){
                if (this.not_allow_change){
                    this.$router.push('qualificationSetting')
                }else{
                    this.dataSettingTips=true
                }

            },
            hideBackTips(bool, flag) {
                if (flag) {
                    this.goBack();
                }
                this.backTips = bool;
            },
            hideSettingTips(bool,flag){
                if (flag) {
                   this.$router.push('qualificationSetting')
                }
                this.dataSettingTips = bool;
            },
            goDataSEtting(bool,flag){
                if (flag) {
                    this.goBack();
                }
                this.backTips = bool;
            },
            checkForm(status) {
                if (!this.vitaForm.id_card_photo_front) {
                    this.$message({
                        type: "error",
                        message: "请上传身份证正面"
                    });
                    return;
                }
                if (!this.vitaForm.id_card_photo_verso) {
                    this.$message({
                        type: "error",
                        message: "请上传身份证反面"
                    });
                    return;
                }
                if (!this.vitaForm.profile_picture) {
                    this.$message({
                        type: "error",
                        message: "请上传二寸白底证件照"
                    });
                    return;
                }
                this.$refs["vitaForm"].validate((valid) => {
                    if (valid) {
                        this.tips=status==='commit' ? '提交后将不可更改，请确认是否提交？' : '请确认是否保存？'
                        this.translateData();
                        this.makeSureSubmit();
                    } else {
                        this.$message({
                            type: "error",
                            message: "请完善所有带*号的必填项"
                        });
                        console.error('error submit!!');
                        return false;
                    }
                });
            },
          revocation(){
            this.revocationBackTips = true;
          },
          hideBackTipsRevocation(bool, flag){
            if (flag) {
              info_revocation().then(({data}) => {
                // console.log(data);
                if (Number(data.status) === 0) {
                  this.$message.success("信息撤销提交成功");
                  this.getInfo();
                }else{
                  this.$message.error(data.msg);
                }
              })
              .catch((err) => {
                console.error(err);
              });
            }
            this.revocationBackTips = bool;
          },
            translateData() {
                // 出生日期转时间戳
                this.$set(this.vitaForm, "date_of_birth", new Date(this.vitaForm.date_of_birth).getTime());
            },
            makeSureSubmit() {
              var url = this.vitaForm.profile_picture;
              // 去掉http
              url = url.replace(/.*\/uploads/,"/uploads")
              console.log(url);
              // 检验是否白底图
              checkPicture({profile_picture:url}).then(({data}) => {
                // console.log(data);
                if (Number(data.status) === 0){
                  let { isCheck, whiteBase } = data.result;
                  if(isCheck && !whiteBase){
                    this.iKnowTips = true;
                    this.$refs.vitaImgInfo.deleteImg();
                  }else{
                    this.submitTips = true;
                  }
                }else{
                  this.submitTips = true;
                }
              })
              .catch((err) => {
                console.error(err);
                this.submitTips = true;
              });
            },
          iKnowHideTips(bool,flag){
            this.iKnowTips=false;
          },
            hideSubmitTips(bool, flag) {
                if (flag) {
                    this.submitForm();
                }
                this.submitTips = bool;
            },
            submitForm() {
                const form = {
                    name: this.vitaForm.name, // 姓名
                    birthday:this.vitaForm.birthday,
                    family_name_spell: this.vitaForm.family_name_spell, // 姓氏
                    given_name_spell: this.vitaForm.given_name_spell, // 名字
                    id_card_photo_front: this.vitaForm.id_card_photo_front, // 身份证照片正面，（一个URL）
                    id_card_photo_verso: this.vitaForm.id_card_photo_verso, // 身份证照片背面，（一个URL）
                    profile_picture: this.vitaForm.profile_picture, // 个人头像，（一个URL）
                    email_address: this.vitaForm.email_address, // 邮箱地址
                    nationality: this.vitaForm.nationality, // 国籍
                    nation: this.vitaForm.nation, // 民族
                };
                student_sign_info_one(form)
                    .then(({data}) => {
                        // console.log(data);
                        if (Number(data.status) === 0) {
                            // vuex更新个人信息
                            const info = {
                                name: this.vitaForm.name.toUpperCase(),
                                mobile_phone: this.vitaForm.mobile_phone,
                                profile_picture: data.result.profile_picture,
                            };
                            this.$store.commit("updateUserInfo", {
                                ...this.userInfo,
                                ...info
                            });
                            this.$message.success("信息保存成功");
                            this.$store.commit("updateinfoRefused", false);
                            // 路由跳转
                            this.goBack();
                        }else if(Number(data.status) === 444) {
                            this.$message({
                                type: "error",
                                message: data.msg
                            });
                            this.emailErr = true;
                            this.emailMsg = data.msg;
                            this.$refs["vitaForm"].validateField("email_address");
                        }else{
                            this.$message.error(data.msg);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            changeSwitch(){
//                this.vitaForm.family_name_spell='';
                this.vitaForm.given_name_spell='';
            },
            querySearch(queryString, cb) {
                if (queryString.indexOf('@') > -1){
                    cb([])
                }else{
                    let res =[
                        { "value": queryString + '@qq.com', "address": queryString + '@qq.com' },
                        { "value": queryString + '@163.com', "address": queryString + '@163.com' },
                        { "value": queryString + '@126.com', "address": queryString + '@126.com' },
                        { "value": queryString + '@sina.com', "address": queryString + '@sina.com' },
                        { "value": queryString + '@yioks.com', "address": queryString + '@yioks.com' },
                        { "value": queryString + '@mail.com', "address": queryString + '@mail.com' },
                        { "value": queryString + '@sohu.com', "address": queryString + '@sohu.com' },
                        { "value": queryString + '@sogou.com', "address": queryString + '@sogou.com' },
                    ]
                    let  results = queryString ? res  : [];
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                }


            },
        },
      watch:{
        // switch_pinyin:{
        //   handler(){
        //     //          this.vitaForm. family_name_spell='';
        //     this.vitaForm. given_name_spell='';
        //       this.$refs["vitaForm"].validateField("family_name_spell");
        //   }
        // }
      },
        filters:{
            auditStatus(status) {
              console.log(status)
                switch (status) {
                    case "audit":
                        status = "待审核";
                        break;
                    case "pass":
                        status = "通过";
                        break;
                    case "refused":
                        status = "拒绝";
                        break;
                    case "perfect":
                        status = "待完善";
                        break;
                    default:
                        status = "";
                        break;
                }
                return status;
            },
        },
    }
</script>

<style lang="stylus">
    .vita-form-main-basic {
        .content {
            .form-wrap {
                .el-form-item__label {
                    color: #fff;
                }
                .vita-edu-row {
                    .el-range-separator {
                        padding: 0;
                    }
                }
                $width = 306px;
                /*.birthday {
                  .el-date-editor {
                    width: $width;
                  }
                }*/
                .gender, .national {
                    .el-select {
                        width: $width;
                    }
                }
            }
        }
    }
</style>
<style lang="stylus" scoped>
    @import "~@/assets/css/variable";
    .vita-form-basic-nav, .vita-form-main-basic {
        flex: 1 1 auto;
        height: 100%;
    }

    .vita-form-basic-nav {
        display: flex;
        align-items: center;
        justify-content space-between
        padding: 0 12px 0 0;
        .myResume{
            background-color: #4cd964;
            font-size 16px
            padding: 5px 10px
            cursor: pointer
        }
        p {
            font-size: $font_size_big;
        }
        .not_allow{
            cursor not-allowed
            background-color #909399
            color $color_white
            font-size 16px
            padding: 5px 10px
        }
    }

    .vita-form-main-basic {
        width: 100%;
        .content {
            height: calc(100% - 60px);
            padding: 20px 0;
            position: relative;
            background-color: $block_bg_color_base;
            .form-wrap {
                padding: 0 30px 0 25px;
                .vita-form-fieldset {
                    margin: 0 0 20px 0;
                    padding: 10px 10px 0;
                    border: 1px solid $color_white;
                    .photo {
                        width: 132px;
                        position: relative;
                        cursor: pointer;
                        .tips-photo {
                            display: none;
                            width: 345px;
                            /*height: 220px;*/
                            position: absolute;
                            /*top: -30px;*/
                            top: 160px;
                            /*left: -250px;*/
                            left: -180px;
                            z-index: 100;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        &:hover {
                            .tips-photo {
                                display: block;
                            }
                        }
                    }
                    .idcard-front-end {
                        width: 260px;
                        position: relative;
                        cursor: pointer

                        .front-end-tips {
                            display: none;
                            width: 345px;
                            /*height: 170px;*/
                            position: absolute;
                            /*top: -5px;*/
                            top: 160px;
                            left: -40px;
                            z-index: 100;
                            /*&.front-tips {
                              left: 260px;
                            }
                            &.end-tips {
                              right: 260px;
                            }*/
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        &:hover {
                            .front-end-tips {
                                display: block;
                            }
                        }
                    }

                    .timeline {
                        display block
                        padding-left 3px
                        .timeline-item {
                            position relative
                            padding-bottom 20px
                            .item_tail {
                                position absolute
                                top 36px
                                bottom 6px
                                left 16px
                                // height 100%
                                border-left 2px solid #cccccc
                            }
                            .item_node {
                                position absolute
                                background-color #fff
                                color #333
                                border 1px solid #fff
                                border-radius 50%
                                // left -2px
                                width 36px
                                height @width
                                font-size: 12px;
                                display flex
                                align-items center
                                text-align: center;
                                justify-content center
                            }
                            .item_wrap {
                                position: relative;
                                padding-left: 50px;
                                top: -3px;
                                .timestamp {
                                    display flex
                                    // align-items center
                                    line-height 1
                                    margin-bottom 5px
                                    font-size 15px
                                    .audit_people {
                                        flex 1
                                        text-align right
                                        margin-left 10px
                                    }
                                }
                                .item_cont {
                                    display block
                                    background-color #fff
                                    color #333
                                    padding 10px
                                    border-radius: 4px;
                                    border: 1px solid #cccccc;
                                    overflow: hidden;
                                    font-size:15px;
                                    box-shadow 0 2px 12px 0 rgba(255,255,255,.1)
                                }
                            }
                        }
                    }
                }
                .vita-edu-row {
                    margin: 0 0 10px 0;
                    padding: 10px 0 0;
                    border: 1px solid $color_white;
                }
                .exp-opt {
                    padding: 60px 0 0;
                }
            }
        }
        .btns {
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            /*background-color: $color_err;*/
        }
    }
</style>

<style lang="stylus" >
    .basic_information_forbidden_click{
        cursor default !important
        .avatar-root .avatar-picture .avatar-uploader{
            cursor no-drop !important
        }
        .el-upload{
            cursor no-drop !important
          }
    }
</style>

